import styles from './index.less';
import IClose from '@imgs/icons/close.svg';
import classNames from 'classnames';

export default function CustomTag(props: any) {
  const {
    color,
    borderColor,
    backgroundColor,
    icon,
    children,
    onClose,
    closable,
    closeIcon,
  } = props;
  return (
    <div
      className={classNames(styles['custom-tag'], props.className)}
      style={{ borderColor, backgroundColor, color }}
    >
      {icon}
      <span className={styles['custom-tag-text']}>{children}</span>
      {closable && !closeIcon ? (
        <IClose
          style={
            {
              '--color': color,
            } as React.CSSProperties
          }
          className={styles.close}
          onClick={onClose}
        />
      ) : (
        ''
      )}
      {closable && closeIcon ? closeIcon : ''}
    </div>
  );
}
